// extracted by mini-css-extract-plugin
export default {"link":"Link_link__72PFA","inline":"Link_inline__NFcHM","inline-underlined":"Link_inline-underlined__i8C6Y","block":"Link_block__Q-W20","centered-block":"Link_centered-block__iddj4"};